<template>
  <div>
      <main>
        <article>
          <h3 class="metricsInitals">NPS</h3>
          <!-- <VueJsCounter class="metricsNo" end="80"></VueJsCounter> -->
          <!-- <span class="metricsUnit">%</span> -->
          <NpsChartAdmin/>
          <p class="metricsDesc">evaluate long-term customer loyalty and happiness</p>
        </article>

        <article>
          <h3 class="metricsInitals">CSAT</h3>
          <!-- <VueJsCounter class="metricsNo" start="1" end="4.5" decimal="."></VueJsCounter> -->
          <!-- <span class="metricsUnit">%</span> -->
          <CsatChartAdmin/>
          <p class="metricsDesc">evaluate short-term guest satisfaction</p>
        </article>

        <article>
          <h3 class="metricsInitals">ACR</h3>
          <!-- <VueJsCounter class="metricsNo"  end="35"></VueJsCounter> -->
          <span class="metricsUnit">%</span>
          <AcrChartAdmin/>
          <p class="metricsDesc">evaluate how many accounts proceed with subcription plan after free trial.</p>
        </article>

        <article>
          <h3 class="metricsInitals">churn rate</h3>
          <!-- <VueJsCounter class="metricsNo" end="10"></VueJsCounter> -->
          <span class="metricsUnit">%</span>
          <ChurnRateChartAdmin/>
          <p class="metricsDesc">percentage of accounts who stop using the platform</p>
        </article>

        <article>
          <h3 class="metricsInitals">DAU</h3>
          <!-- <VueJsCounter class="metricsNo" start="1" end="568" ></VueJsCounter> -->
          <DauChartAdmin/>
          <p class="metricsDesc">daily active accounts</p>
        </article>

        <article>
          <h3 class="metricsInitals">CES</h3>
          <!-- <VueJsCounter class="metricsNo"  end="5"></VueJsCounter> -->
          <CesChartAdmin/>
          <p class="metricsDesc">measures how much effort a client has to exert to use our service (scale 1-7)</p>
        </article>

        <article>
          <h3 class="metricsInitals">MRR</h3>
          <!-- <VueJsCounter class="metricsNo" start="1" end="568" ></VueJsCounter> -->
          <span class="metricsUnit">EUR</span>
          <MrrChartAdmin/>
          <p class="metricsDesc">income that a business can count on receiving every single month </p>
        </article>

        <article>
         <span style="font-size: 1,2em;">Expansion</span><h3 class="metricsInitals"> MRR</h3>
          <!-- <VueJsCounter class="metricsNo"  end="5"></VueJsCounter> -->
          <span class="metricsUnit">%</span>
          <ExpMrrChartAdmin/>
          <p class="metricsDesc">measure the amount of additional revenue coming from existing customers</p>
        </article>

        <article>
          <h3 class="metricsInitals">ACV</h3>
          <!-- <VueJsCounter class="metricsNo"  end="5"></VueJsCounter> -->
          <span class="metricsUnit">EUR</span>
          <AcvChartAdmin/>
          <p class="metricsDesc">average annual contract value of a client subscription</p>
        </article>
      </main>
  </div>
</template>

<script>
import axios from 'axios'
// import VueJsCounter from 'vue-js-counter'
import NpsChartAdmin from '@/components/charts/NpsChartAdmin.vue'
import CsatChartAdmin from '@/components/charts/CsatChartAdmin.vue'
import AcrChartAdmin from '@/components/charts/AcrChartAdmin.vue'
import ChurnRateChartAdmin from '@/components/charts/ChurnRateChartAdmin.vue'
import DauChartAdmin from '@/components/charts/DauChartAdmin.vue'
import CesChartAdmin from '@/components/charts/CesChartAdmin.vue'
import MrrChartAdmin from '@/components/charts/MrrChartAdmin.vue'
import ExpMrrChartAdmin from '@/components/charts/ExpMrrChartAdmin.vue'
import AcvChartAdmin from '@/components/charts/AcvChartAdmin.vue'







// import ProductService from '@/services/ProductService.js'

//import ProductCard from '@/components/ui/ProductCard.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

//import { mapState } from 'vuex'

export default {
  components: {
    // VueJsCounter,
    NpsChartAdmin,
    CsatChartAdmin,
    AcrChartAdmin,
    ChurnRateChartAdmin,
    DauChartAdmin,
    CesChartAdmin,
    MrrChartAdmin,
    ExpMrrChartAdmin,
    AcvChartAdmin
  },
  data() {
    return {
      isLoading: true,
      clientInfo: null,
      loading: true,
      errored: false,
      id: this.client.id  //! sql: "DELETE from clients WHERE id = 'undefined'"
    }
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/clients`)
      .then(response => {
        this.clientInfo = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))  },
  methods: {
    deleteClient() {
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('client/removeClient', this.id)
          // .then(() => {
          //   this.$router.push({
          //     path: '/products'
          //   })
          // })
          .catch(e => console.log(e))
      }
    }
  },
  props: {
    client: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>

* {
  box-sizing: border-box;
}

main {
  max-width: 1200px;
  margin: 30px auto;
  padding: 0 20px;
  width: 100%; 
  display: grid;
  /* Define Auto Row size */
  // grid-auto-rows: 100px; 
  /*Define our columns */
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); 
  grid-gap: 1em;
}

article {
  border-radius: 10px;
  padding: 20px;
  color: #fff;
}

.metricsNo {
  font-size: 4em;
  font-weight: 800;
  padding-left: 2px;
  display: inline;
}
.metricsUnit {
  font-size: 2.5em;
}
.metricsInitals {
  font-weight: 400;
  font-size: 2.7em;
  padding-left: 0px;
  letter-spacing: 2px;
}
.metricsDesc {
  font-size: 1em;
}

article:nth-child(1) {
  background-color: #d49050de;
}

article:nth-child(2) {
  background-color: #d49050de;
}
article:nth-child(3) {
  background-color: #d49050de;
}
article:nth-child(4) {
  background-color: #d49050de;
}
article:nth-child(5) {
  background-color: rgba(212, 144, 80, 0.871);
}
article:nth-child(6) {
  background-color: #d49050de;
}
article:nth-child(7) {
  background-color: var(--bg);
}
article:nth-child(8) {
  background-color: var(--bg);
}
article:nth-child(9) {
  background-color: var(--bg);
}

</style>

